export default "__VITE_ASSET__36f9dbe9__"